import { SetStateAction, Dispatch } from "react";
import { Button } from "@/components/ui/button";
import { Feature, LineString } from "geojson";
import { CloseIcon } from "components/icons";

type SelectedMultipleCurbZoneDetailProps = {
  curbZones: Feature<LineString>[];
  resetState: () => void;
  openCurbZoneMultiModal: Dispatch<SetStateAction<boolean>>;
};

export const SelectedMultipleCurbZoneDetail = ({
  curbZones,
  resetState,
  openCurbZoneMultiModal,
}: SelectedMultipleCurbZoneDetailProps) => {
  return (
    <div className="transition-opacity absolute h-auto top-36 bg-primary p-3 right-6 mt-2 mb-3 rounded-md shadow-lg z-10">
      <div className="flex justify-end h-6 cursor-pointer">
        <CloseIcon className="text-white w-4 h-4" onClick={resetState} />
      </div>
      <div>
        <div className="flex gap-8 py-2">
          <span className="text-sm text-secondary">Currently selecting</span>
          <span className="text-sm text-secondary">{curbZones?.length} Curb Zones</span>
        </div>
      </div>
      <div className="flex justify-between">
        <Button onClick={() => openCurbZoneMultiModal(true)} variant="secondary">
          Create
        </Button>
      </div>
    </div>
  );
};
